export const getBoringAvatar = (wallet: string | undefined) => {
  return `https://cred.boringavatars.cc/api/avatar?name=${wallet}`
}